var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-pagelet-text px-5"},[_c('markdown-viewer',[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }